export const MultiLangMixin = {
    methods: {
        getContentForLanguage(contentArray, language, propertyName, defaultValue) {
            if (propertyName == null) {
                propertyName = 'value';
            }

            if (defaultValue == null) {
                defaultValue = '-'
            }

            var contentObject = this.getObjectForLanguage(contentArray, language);

            if (contentObject != null) {
                return contentObject[propertyName];
            }

            return defaultValue;
        },

        getObjectForLanguage(contentArray, language) {
            for (var i = 0; i < contentArray.length; i++) {
                var contentObject = contentArray[i];
                if (contentObject.language.toLowerCase() == language.toLowerCase()) {
                    return contentObject;
                }
            }

            return null;
        },

        setContentForLanguage(contentArray, language, contentValue, propertyName) {
            if (propertyName == null) {
                propertyName = 'content'
            }

            var contentObject = this.getObjectForLanguage(contentArray, language)

            if (contentObject != null) {
                contentObject[propertyName] = contentValue
            } else {
                contentObject = {}
                contentObject[propertyName] = contentValue
                contentObject['language'] = language

                contentArray.push(contentObject)
            }
        }
    }
}